import Qs from 'qs';

/**
 * Modify the outgoing request parameters.
 *
 * @link https://github.com/axios/axios/issues/738#issuecomment-412905574
 * @param {Ibject} config Axios request config
 */
var paramsInterceptor = function paramsInterceptor(config) {
  config.paramsSerializer = function (params) {
    return Qs.stringify(params, {
      arrayFormat: 'indices',
      encode: false
    });
  };
  return config;
};
export default paramsInterceptor;